
import React from 'react';
import { Helmet } from 'react-helmet-async';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import PageHeader from '../components/common/PageHeader';
import BlogGrid from '../components/blog/BlogGrid';

const Blog: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>AI Insights & Trends for NZ Business | ThinkTomorrow.AI</title>
        <meta name="description" content="Practical AI guides, workflow automation tips, and industry updates for New Zealand small and medium businesses." />
        <link rel="canonical" href="https://thinktomorrow.ai/blog" />
        <meta property="og:title" content="AI Insights & Trends for NZ Business | ThinkTomorrow.AI" />
        <meta property="og:description" content="Practical AI guides and workflow automation tips for New Zealand SMEs." />
        <meta property="og:url" content="https://thinktomorrow.ai/blog" />
        <meta property="og:type" content="website" />
      </Helmet>
      <Navbar />
      <main className="min-h-screen pt-16 md:pt-24">
        <PageHeader 
          title="AI Insights & Trends"
          subtitle="Expert tips, industry updates, and practical guides on AI for business in New Zealand. Stay ahead of the curve."
        />
        <div className="py-8 md:py-12 px-4 sm:px-6 lg:px-8">
          <BlogGrid />
        </div>
      </main>
      <Footer />
    </>
  );
};

export default Blog;
